import { graphql } from "react-relay";

export const GET_GM_SESSION = graphql`
  mutation GetOrCreateGreenMachineSessionMutation(
    $input: GetOrCreateGreenMachineSessionsInput!
  ) {
    getOrCreateGreenMachineSessions(input: $input) {
      greenMachineSessions {
        id
        numLineups
        minSalary
        maxSalary
        playersPerLineup
        greenmachinelineupsetSet {
          edges {
            node {
              id
            }
          }
        }
        slate {
          gameType {
            gametypelineupsetSet {
              edges {
                node {
                  lineupSet {
                    lineuprosterslotSet {
                      edges {
                        node {
                          order
                          amount
                          rosterSlot {
                            name
                          }
                          selectable
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
